<template>
  <div class="ls-login-page">
    <!-- Logo area -->
    <div class="ls-logo-area">
      <svg width="260" height="204" viewBox="0 0 250 196" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M97.3286 24.6607L217.049 24.6538C216.439 26.5896 215.468 29.0454 214.759 30.9866L210.386 42.9378L165.568 42.9393C156.165 42.9403 146.512 43.0695 137.145 42.9213C137.807 45.6955 138.622 49.8656 139.098 52.6815L198.424 52.6796L206.743 52.6745C201.531 67.3778 195.578 82.0879 190.362 96.7995C177.531 97.9917 164.554 98.6221 151.709 99.7579C148.482 100.043 145.038 100.345 141.806 100.474C141.67 93.3225 141.793 85.6755 141.808 78.4938L159.016 77.1112C160.017 74.0217 161.007 70.1133 161.889 66.9324C147.729 67.8467 133.527 69.3149 119.363 70.2918C115.468 70.5605 111.448 70.8615 107.572 71.2591C106.718 67.9313 105.964 63.9811 105.22 60.5788L100.155 37.3992C99.255 33.283 98.3545 28.7224 97.3286 24.6607Z" fill="#771AFF"/>
        <path d="M56.2523 6.81316C65.3134 6.74681 74.3749 6.76146 83.4357 6.85712C83.8478 9.43366 84.8431 13.3612 85.4249 15.9836L89.3124 33.5178L100.019 81.7885C103.343 81.4581 106.934 81.2537 110.284 81.005L132.089 79.3712C132.006 86.6125 132.043 94.0206 132.077 101.266L113.861 102.685L74.387 105.763L56.5951 25.0364C51.3665 24.5678 46.3941 26.5953 41.5962 22.5136C36.7298 18.3737 38.808 8.8706 44.926 7.28144C47.3592 6.6494 53.3553 6.85299 56.2523 6.81316Z" fill="#771AFF"/>
        <path d="M95.3172 109.109C102.737 108.234 109.456 113.578 110.322 121.043C111.188 128.508 105.873 135.265 98.4523 136.133C91.0365 137 84.3252 131.656 83.4597 124.197C82.5944 116.737 87.9022 109.983 95.3172 109.109Z" fill="#771AFF"/>
        <path d="M157.284 109.108C164.691 108.24 171.4 113.569 172.277 121.02C173.153 128.472 167.869 135.23 160.464 136.127C153.04 137.024 146.3 131.691 145.421 124.219C144.541 116.749 149.856 109.979 157.284 109.108Z" fill="#771AFF"/>
      </svg>
      <p class="ls-brand-name">{{ $t('login.brandName') }}</p>
    </div>

    <!-- Login card -->
    <div class="ls-card">
      <h2 class="ls-card-title">{{ $t('login.welcomeBack') }}</h2>
      <p class="ls-card-subtitle">{{ $t('login.signInToContinue') }}</p>

      <form @submit.prevent="loginWithPhoneAndPassword()">
        <div class="ls-field">
          <CountryPhoneInput
            v-model="formData.phone_number"
            :label="$t('login.phoneNumber')"
            placeholder="7xxxxxxxxx"
            @update:isValid="phoneValid = $event"
          />
        </div>

        <div class="ls-field">
          <v-text-field
            ref="passwordField"
            :label="$t('login.password')"
            v-model="formData.password"
            :error-messages="errors.collect('Password')"
            v-validate="'required'"
            data-vv-name="Password"
            :append-icon="e1 ? 'visibility_off' : 'visibility'"
            :append-icon-cb="() => (e1 = !e1)"
            :type="e1 ? 'text' : 'password'"
            class="ls-password-field"
          />
        </div>

        <button
          type="submit"
          class="ls-login-btn"
          :class="{ 'ls-login-btn--loading': loading }"
          :disabled="!phoneValid || loading"
        >
          <span v-if="!loading">{{ $t('login.loginButton') }}</span>
          <span v-else class="ls-spinner"></span>
        </button>
      </form>

      <p class="ls-signup-text">
        {{ $t('login.noAccount') }}
        <a
          href="#"
          class="ls-signup-link"
          @click.prevent="$router.push('/customer-registration')"
        >{{ $t('login.signUp') }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import CountryPhoneInput from './shared/CountryPhoneInput.vue'

export default {
  props: ['changeLogin', 'changePhoneLogin'],

  components: {
    CountryPhoneInput
  },

  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      e1: false,
      loading: false,
      phoneValid: false,
      formData: {
        phone_number: '',
        password: null
      }
    }
  },
  methods: {
    loginWithPhoneAndPassword() {
      this.$validator.validateAll().then((res) => {
        if (res && this.phoneValid) {
          let payload = { ...this.formData }
          this.changePhoneLogin(payload)
        }
      })
    }
  }
}
</script>

<style scoped>
.ls-login-page {
  min-height: 100vh;
  background-color: #FFC83D;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 60px 16px 40px;
  font-family: 'Segoe UI', Arial, sans-serif;
}

/* Logo area */
.ls-logo-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 28px;
}

.ls-brand-name {
  font-size: 32px;
  font-weight: 800;
  font-style: italic;
  color: #771AFF;
  margin: -35px 0 0;
  letter-spacing: 0.5px;
}

/* Card */
.ls-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 36px 32px 28px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.12);
}

.ls-card-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 4px;
}

.ls-card-subtitle {
  font-size: 14px;
  color: #777;
  margin: 0 0 24px;
}

/* Fields */
.ls-field {
  margin-bottom: 8px;
}

.ls-field >>> .v-input__slot::after {
  border-color: #771AFF !important;
}

.ls-field >>> .v-label--active {
  color: #771AFF !important;
}

/* Login button */
.ls-login-btn {
  display: block;
  width: 100%;
  margin-top: 20px;
  padding: 14px;
  background-color: #771AFF;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease, opacity 0.2s ease;
  letter-spacing: 0.5px;
}

.ls-login-btn:hover:not(:disabled) {
  background-color: #6010e0;
}

.ls-login-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.ls-login-btn--loading {
  pointer-events: none;
}

/* Inline spinner */
.ls-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 3px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: ls-spin 0.7s linear infinite;
  vertical-align: middle;
}

@keyframes ls-spin {
  to { transform: rotate(360deg); }
}

/* Sign-up text */
.ls-signup-text {
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  color: #555;
}

.ls-signup-link {
  color: #771AFF;
  font-weight: 700;
  text-decoration: none;
}

.ls-signup-link:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/loginComponent.vue